import axios from 'axios'

const BASEURLZAI = axios.create({
    baseURL: process.env.REACT_APP_API_ZAI,
    headers: {
        'Content-Type': 'application/json',
        'idorganizacao': process.env.REACT_APP_ORGANIZACAO_HG
    }
})

export default BASEURLZAI